import React, { useState, useContext, useMemo, useCallback } from 'react';
import { Img, svgSprite, A } from '../../../hybrid/wrappers';
import UserContext, { StoreContext, UserProfileContext } from '../../../common/utils/getContext';
import SpecialStatus from '../SpecialStatus';
import T from '../../../common/components/T';
import { addProductFunction, wishProductFunction } from '../helpers';
import PropTypes from 'prop-types';
import FormCheckbox from '../../form/components/form-checkbox/FormCheckbox/FormCheckbox';
import uikit from '../../../project/uikit/styles';
import css from './Product.module.scss';
import classnames from 'classnames';
import { LangContext } from '../../../common/decorators/Language';
import SingleButton from '../../form/form-control-buttons/SingleButton/SingleButton';
import Image from 'next/image';

const Product = ({
    product,
    // slider = false,
    stylesMix,
    type,
    selectProduct,
    isAllowAddProduct,
    setAllowAddProduct,
    isLoadingPrice
}) => {
    const [allow, setAllow] = useState(true);
    const compStyles = { ...css, ...stylesMix };
    const { cartData, setCartData, setCart, setWishlist, wishlist, setShowRegWindow, isLoading } = useContext(StoreContext);
    const { setAlertData, userToken, lang, localization } = useContext(UserContext);
    const { profileData } = useContext(UserProfileContext);
    const { translation } = useContext(LangContext) || {};
    const isInWishList = useMemo(() => wishlist?.data && wishlist.data.find((id) => id === product.id), [product.id, wishlist]);

    const addProduct = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (isAllowAddProduct && !isLoading) {
            // if (!userToken) {
            //     setCantBuyModal(true);
            //     return;
            // }
            setAllowAddProduct(false);
            await addProductFunction(
                e,
                cartData,
                product,
                setCartData,
                setCart,
                setAlertData,
                userToken,
                lang,
                localization,
                setAllowAddProduct,
                profileData
            );
        }
    };
    const wishProductFunc = useCallback(
        async (token) => {
            await wishProductFunction(
                product,
                isInWishList,
                setWishlist,
                token,
                lang,
                localization,
                setAllow,
                setAlertData,
                translation
            );
        },
        [product, isInWishList, setWishlist, lang, localization, setAlertData, translation]
    );
    const wishProduct = () => {
        if (!userToken) {
            return setShowRegWindow({ handler: wishProductFunc });
        }
        if (!allow) return;
        setAllow(false);
        wishProductFunc(userToken);
    };

    const productType = product?.properties?.find((prop) => prop.name === 'gtshop::type')?.value;

    const hrefData = { as: `/store/product/${product.id}`, pathname: `/store/product/[...data]`, query: { data: [product.id] } };

    const isAvailable = product?.product_availability !== 'not_in_stock';

    return type === 'slider' ? (
        <div className={classnames('fakeLink', css.productHover, compStyles.productWrapperInner)}>
            {/* <div className={compStyles.productWishButton}>
                {selectProduct ? (
                    <FormCheckbox
                        compStyle={{
                            label: uikit.mb0,
                            checkBox: {
                                width: '32px',
                                height: '32px',
                                marginRight: '0'
                            },
                            formCheckboxActive: {
                                borderColor: 'var(--greenDeepColor)',
                                backgroundColor: 'var(--greenDeepColor)'
                            },
                            checkboxSvg: { width: '14px', height: '14px' }
                        }}
                        setFormData={selectProduct?.func}
                        attribute={product.id}
                        value={selectProduct?.value.find((prod) => prod === product.id) ? '1' : '0'}
                    />
                ) : (
                    <div onClick={wishProduct} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {svgSprite(isInWishList ? 'heart-fill' : 'heart', {
                            width: '18px',
                            height: '18px',
                            fill: 'var(--blueColor)'
                        })}
                    </div>
                )}
            </div> */}
            <A href={hrefData} className={compStyles.productItem}>
                {/* <SpecialStatus type={type} compStyles={compStyles} statuses={product.special_statuses} /> */}
                <div>
                    <div className={classnames(css.productImage, !product?.image?.links?.preview ? css.productImageEmpty : {})}>
                        <Img src='/src/img/store/ProductBG.png' alt='ProductBG' className={css.productImageBg} />
                        {product?.image?.links?.preview ? (
                            <Img
                                width={200}
                                height={200}
                                className={compStyles.productImageItem}
                                src={product?.image?.links?.preview}
                                quality={100}
                            />
                        ) : (
                            svgSprite('product-no-image', {
                                width: '64px',
                                height: '64px',
                                className: compStyles?.productImageSvg
                            })
                        )}
                    </div>
                    <div className={compStyles?.productUnderImageWrapper}>
                        <div className={compStyles?.productUnderImage}>
                            {productType ? <div className={compStyles?.productType}>{productType}</div> : null}
                            <div
                                className={classnames(
                                    compStyles.productName,
                                    product?.name?.length >= 150 ? compStyles.productNameGrey : ''
                                )}
                            >
                                {product.name}
                            </div>
                            <div
                                className={classnames(
                                    compStyles.totalPriceMedium,
                                    isLoadingPrice ? compStyles.isLoadingPrice : compStyles.loadedPrice
                                )}
                            >
                                {product?.price?.price_for_client_formatted}
                            </div>
                            {/* {product?.price?.scores_for_client && (
                                <div className={compStyles.totalMarketingPrice}>{product?.price?.scores_for_client_formatted}</div>
                            )} */}
                            <SingleButton
                                type='cancel'
                                buttonText={<T textName='add-to-cart-v1' defaultStr='В корзину' />}
                                customButton={{
                                    singleButton: compStyles?.toCartBtn,
                                    butWrapper: compStyles?.toCartBtnInner
                                }}
                                clickFunc={addProduct}
                            />
                        </div>
                        <div onClick={addProduct} className={classnames('circleButton', compStyles?.productMobileButton)}>
                            {svgSprite('arrow-right')}
                        </div>
                    </div>
                </div>
            </A>
        </div>
    ) : (
        <div className={classnames('fakeLink', css.productHover, compStyles.productWrapperInner)}>
            <div className={compStyles.productWishButton}>
                {selectProduct ? (
                    <FormCheckbox
                        compStyle={{
                            label: uikit.mb0,
                            checkBox: {
                                width: '32px',
                                height: '32px',
                                marginRight: '0'
                            },
                            formCheckboxActive: {
                                borderColor: 'var(--greenDeepColor)',
                                backgroundColor: 'var(--greenDeepColor)'
                            },
                            checkboxSvg: { width: '14px', height: '14px' }
                        }}
                        setFormData={selectProduct?.func}
                        attribute={product.id}
                        value={selectProduct?.value.find((prod) => prod === product.id) ? '1' : '0'}
                    />
                ) : (
                    <div onClick={wishProduct} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {svgSprite(isInWishList ? 'heart-fill' : 'heart', {
                            width: '18px',
                            height: '18px',
                            fill: 'var(--blueColor)'
                        })}
                    </div>
                )}
            </div>
            <A href={hrefData} className={compStyles.productItem}>
                <SpecialStatus product={product} type={type} compStyles={compStyles} statuses={product.special_statuses} />
                <div className={compStyles?.imageInfoWrapper}>
                    <div className={css.productImage}>
                        <Image fill src='/src/img/store/ProductBG.png' alt='ProductBG' className={css.productImageBg} />
                        {product?.image?.link || product?.image?.links?.large || product?.image?.links?.preview ? (
                            <Img
                                width={200}
                                height={200}
                                className={compStyles.productImageItem}
                                src={product?.image?.link || product?.image?.links?.large || product?.image?.links?.preview}
                                quality={100}
                                loading={'lazy'}
                                layout='responsive'
                                alt={product.name}
                            />
                        ) : (
                            svgSprite('product-no-image', {
                                width: '64px',
                                height: '64px',
                                className: compStyles?.productImageSvg
                            })
                        )}
                    </div>
                    {productType ? <div className={compStyles?.productType}>{productType}</div> : null}
                    <div
                        className={classnames(
                            compStyles.productName,
                            product?.name?.length >= 150 ? compStyles.productNameGrey : ''
                        )}
                    >
                        {product.name}
                    </div>
                    <div className={compStyles?.productUnderImageWrapper}>
                        <div className={compStyles?.productUnderImage}>
                            <div className={classnames(compStyles?.productPrices)}>
                                <div
                                    className={classnames(
                                        compStyles.totalPriceMedium,
                                        isLoadingPrice ? compStyles.isLoadingPrice : compStyles.loadedPrice
                                    )}
                                >
                                    {product?.price?.price_for_currency_formatted}
                                </div>
                                {product?.price?.price_for_client_formatted && userToken && (
                                    <div className={compStyles.totalMarketingPrice}>
                                        {product?.price?.price_for_client_formatted}
                                    </div>
                                )}
                            </div>
                            {isAvailable ? (
                                <>
                                    <SingleButton
                                        type='cancel'
                                        buttonText={<T textName='add-to-cart-v1' defaultStr='В корзину' />}
                                        customButton={{
                                            singleButton: compStyles?.toCartBtn,
                                            butWrapper: compStyles?.toCartBtnInner
                                        }}
                                        clickFunc={addProduct}
                                    />
                                </>
                            ) : (
                                <p className={compStyles?.productAvailability}>{product?.product_availability_translated}</p>
                            )}
                        </div>
                        {isAvailable ? (
                            <div onClick={addProduct} className={classnames('circleButton', compStyles?.productMobileButton)}>
                                {svgSprite('cart-new')}
                            </div>
                        ) : null}
                    </div>
                </div>
            </A>
        </div>
    );
};
Product.propTypes = {
    product: PropTypes.object,
    slider: PropTypes.bool,
    styles: PropTypes.object,
    stylesMix: PropTypes.object,
    type: PropTypes.oneOf(['slider'])
};
export default Product;
